import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PriceLevelDefaultOrder from '../components/PriceLevelDefaultOrder';
import BestAvailableSeatPicker from '../components/BestAvailableSeatPicker';
import TicketPickerCardHeader from '../components/TicketPickerCardHeader';
import Skeleton from '../../../../shared/Skeleton';
import ContainerProps from './PriceLevelWrapperComponent';
import { setBestAvailableQuantities, setSectionLevelQuantities } from '../../../actions/reservedSeating';
import { TICKET_FEE_SEPARATE } from '../../../reducers/ui';
import { getFeeDisplayOption, isKioskMode, isAlwaysShowHiddenLevels } from '../../../selectors/ui';
import { getMainEvent } from '../../../selectors/event';
import {
    getSectionPriceLevels,
    hideBestAvailable,
    disableBestAvailable,
    purchaseLimit,
    incrementBy,
    getSectionFeeMap,
    defaultPriceLevelName,
    hidePremierePriceDiscount,
    getReserveCouponUsage,
} from '../../../selectors/reserved-seating';
import Translation from '@checkout-s/Translation';
import { getFetchedEventPriceLevels } from '../../../selectors/event';


class PriceLevelWrapper extends Component<ContainerProps> {

    defaultHeader = () => {
        return <Translation>{this.props.showBestAvailablePicker ? 'checkout__section' : 'checkout__tickets'}</Translation>;
    }

    render() {
        return(
            <TicketPickerCardHeader header={this.props.header !== undefined ? this.props.header : this.defaultHeader()}>
                {this.props.children}
                {!this.props.showBestAvailablePicker && (
                    <PriceLevelDefaultOrder
                        priceLevels={this.props.priceLevels}
                        levelFilter={this.props.levelFilter}
                        componentName="PriceLevelContainer"
                        isKioskMode = {this.props.isKioskMode}
                        alwaysShowHiddenLevels={this.props.alwaysShowHiddenLevels}
                    />
                )}
                {!!this.props.showBestAvailablePicker && (
                    <BestAvailableSeatPicker
                        priceLevels={this.props.priceLevels}
                        sectionPriceLevels={this.props.sectionPriceLevels}
                        sectionFeeMap={typeof this.props.sectionFeeMap === 'object' && !!Object.keys(this.props.sectionFeeMap).length ? this.props.sectionFeeMap : {}}
                        hideBestAvailable={this.props.hideBestAvailable}
                        disableBestAvailable={this.props.disableBestAvailable}
                        discloseFee={this.props.discloseFee}
                        defaultPriceLevelName={this.props.defaultPriceLevelName}
                        hidePremierePriceDiscount={this.props.hidePremierePriceDiscount}
                        purchaseLimit={this.props.purchaseLimit}
                        quantities={this.props.bestAvailableQuantities}
                        sectionLevelQuantities={this.props.sectionLevelQuantities}
                        onSetQuantities={this.props.setBestAvailableQuantities}
                        onSetSectionLevelQuantities={this.props.setSectionLevelQuantities}
                        isKioskMode={this.props.isKioskMode}
                        incrementBy={this.props.incrementBy}
                        reserveCouponUsage={this.props.reserveCouponUsage}
                        locale={this.props.locale}
                        reservedPriceLevels = {sectionSeat(this.props?.reserveCouponUsage, this.props?.priceLevels)}
                        feeVerbiage = {this.props.feeVerbiage}
                    />
                )}
            </TicketPickerCardHeader>
        )
    }
}

const sectionSeat = (reserveCouponUsage, priceLevels) => {
    if (reserveCouponUsage) {
        const priceLevelValues =  Object.values(priceLevels).filter(lvl => +lvl?.transaction_limit > 0);
        const validReservePlIds = reserveCouponUsage.attributes.valid_reserve_price_level_ids.map(plId => +plId);
        let filteredPriceLevels =  priceLevelValues.filter(e => validReservePlIds.includes(Number(e.price_level_id)));
        let reservedPriceLevels = {};
        filteredPriceLevels.forEach(function(reservedLevel, index) {
            reservedPriceLevels[reservedLevel.price_level_id] = reservedLevel;
        });
        return reservedPriceLevels;
    }
    return {};
}

const mapStateToProps = state => {
    return {
        priceLevels: getFetchedEventPriceLevels(state),
        levelFilter: state.ui.listingConfig.levels,
        header: state.ui.checkoutConfig.priceLevelsHeader,
        sectionPriceLevels: getSectionPriceLevels(state),
        sectionFeeMap: getSectionFeeMap(state),
        hideBestAvailable: hideBestAvailable(state),
        disableBestAvailable: disableBestAvailable(state),
        discloseFee: getFeeDisplayOption(state) == TICKET_FEE_SEPARATE,
        purchaseLimit: purchaseLimit(state),
        incrementBy: incrementBy(state),
        defaultPriceLevelName: defaultPriceLevelName(state),
        hidePremierePriceDiscount: hidePremierePriceDiscount(state),
        bestAvailableQuantities: state.reservedSeating.bestAvailableQuantities,
        sectionLevelQuantities: state.reservedSeating.sectionLevelQuantities,
        isKioskMode: isKioskMode(state),
        reserveCouponUsage: getReserveCouponUsage(state),
        locale: state.intl.locale ? state.intl.locale : 'en-US',
        feeVerbiage: getMainEvent(state)?.event?.fee_verbiage,
        alwaysShowHiddenLevels: isAlwaysShowHiddenLevels(state),
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setBestAvailableQuantities,
        setSectionLevelQuantities,
    }, dispatch);
};

PriceLevelWrapper.propTypes = {
    priceLevels: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceLevelWrapper)
